import Badge from 'react-bootstrap/Badge';
import LoadingButton from '@enerex/unified-ui-react/LoadingButton';
import CloseIcon from '@enerex/unified-ui-react/icons/CloseIcon';
import './FilterPills.scss';

// Match Pricing's labelled pills while keeping removal keyboard accessible.
const FilterPills = ({ filters, disabled = false }) => {
    const active = filters.filter(filter => filter.value !== '' && filter.value != null);
    if (!active.length) return null;
    return <div className="d-flex flex-wrap gap-2 mt-2 mb-2" aria-label="Applied filters">
        {active.map(({ label, value, onRemove }) => <Badge key={label} bg="secondary"
            className="filter-pill d-inline-flex align-items-center gap-2 mw-100 text-wrap">
            <span className="filter-pill__text"><span className="filter-pill__label">{label}:</span>{' '}<span className="filter-pill__value">{value}</span></span>
            <LoadingButton type="button" variant="link" className="filter-pill__remove p-0 text-reset flex-shrink-0"
                aria-label={`Remove ${label.toLowerCase()} filter`} disabled={disabled} onClick={onRemove}>
                <CloseIcon aria-hidden="true" />
            </LoadingButton>
        </Badge>)}
    </div>;
};

export default FilterPills;
